module.exports = __webpack_public_path__ + "static/The_Anime_Times_Logo-133dd91e71ef837a7bad2abbd8feb5b6.png";